import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M16 3a13.28 13.28 0 1 0 13.28 13.28A13.3 13.3 0 0 0 16 3zm0 25.25a12 12 0 1 1 12-12 12 12 0 0 1-12 12z' }),
  React.createElement('path', { d: 'M14.89 9.84L10 14.74l.92.92 4.45-4.45V23h1.3V11.21l4.45 4.45.92-.92-4.91-4.9a1.56 1.56 0 0 0-2.24 0z' })
));